import ImageData from '@/ts/ImageData';

export default class OptionsData {
    public id: number;
    public productName: string;
    public description: string;
    public price: number;
    public color: string;
    public serialNumber: string;
    public selected: boolean;
    public category: number;
    public defaultOption: number;
    public optionImageGUID: string | null;
    public optionImage: ImageData | null;
    
    constructor(
        id: number,
        productName: string,
        description: string,
        price: number,
        color: string,
        serialNumber: string,
        category: number,
        defaultOption: number,
        optionImageGUID: string | null,
    ) {
        this.id = id;
        this.productName = productName;
        this.description = description;
        this.price = price;
        this.color = color;
        this.serialNumber = serialNumber;
        this.selected = false;
        this.category = category;
        this.defaultOption = defaultOption;
        this.optionImageGUID = optionImageGUID;
    }
}
